import React from 'react'
import styled from 'styled-components'
import { Column } from './layout'
import { useStore } from 'effector-react'
import { officalFeeStore } from '../store'

interface Props {
  name: string
  index: number
  price: number
  content: string[]
  description?: string
  withFilingFee?: boolean
}

export default function Plan({
  index,
  name,
  price,
  content,
  description,
  withFilingFee = false,
}: Props) {
  const officalFee = useStore(officalFeeStore)

  return (
    <Container gutter={16}>
      <Name>
        套餐{index + 1}：{name}
      </Name>
      <Price>
        价格：<span className="number">{price}</span>
        {withFilingFee && !!officalFee && `+${officalFee}`}
      </Price>
      <Content>
        {content.map(c => (
          <li key={c}>{c}</li>
        ))}
      </Content>
      {description && <Description>{description}</Description>}
    </Container>
  )
}

const Container = styled(Column)`
  flex: 1;
`

const Name = styled.strong`
  font-size: 20px;
  line-height: 28px;
  color: #005b97;
`

const Price = styled.span`
  font-size: 20px;
  line-height: 28px;

  .number {
    font-size: 28px;

    &::before {
      content: '$';
    }
  }
`

const Content = styled.ul`
  padding-left: 1rem;
  font-size: 14px;
  line-height: 24px;
  color: #364d6e;
  flex: 1;
`

const Description = styled.div`
  font-size: 0.8em;

  &::before {
    content: '*';
  }
`
